import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["formatPattern", "redaction", "mask", "onChange", "defaultValue", "value", "component"];
import "core-js/modules/es6.array.slice.js";
import React from 'react';
import PropTypes from 'prop-types';
import { usePatternFormatter } from './use-pattern-formatter'; // Wrapper for Input component that manages:
//   - formatting an input value to a pattern as the user types
//   - redacting some or all of the value that is visible to the user
//   - applying a mask after the value to hint at what remains
//   - providing the formatted value without redaction or mask to onChange

export var InputFormattedPattern = function InputFormattedPattern(_ref) {
  var formatPattern = _ref.formatPattern,
      redaction = _ref.redaction,
      mask = _ref.mask,
      onChange = _ref.onChange,
      defaultValue = _ref.defaultValue,
      valueProp = _ref.value,
      Component = _ref.component,
      props = _objectWithoutProperties(_ref, _excluded);

  var initialValue = "".concat(valueProp || defaultValue || '');

  var _usePatternFormatter = usePatternFormatter({
    formatPattern: formatPattern,
    initialValue: initialValue,
    onChange: onChange
  }),
      _usePatternFormatter2 = _slicedToArray(_usePatternFormatter, 3),
      formatter = _usePatternFormatter2[0],
      inputRef = _usePatternFormatter2[1],
      onInputChange = _usePatternFormatter2[2]; // apply masking and redactions


  var value = formatter.value;

  if (value.length) {
    // apply the redaction
    var redacted = redaction.slice(0, formatter.format(value).length);
    value = redacted + value.slice(redacted.length, value.length); // apply the mask

    value += mask.slice(value.length, mask.length);
  }

  return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    ref: inputRef,
    onChange: onInputChange,
    value: value
  }));
};
InputFormattedPattern.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // formatPattern:
  //  '9' is numeral
  //  'a' is alpha
  //  'x' is alphanumeric
  //  any other character is a delimiter in the pattern
  formatPattern: PropTypes.string.isRequired,
  // redaction:
  //  string to apply over input value as the user types
  redaction: PropTypes.string,
  // mask: string to hint at remaining characters the user should type
  mask: PropTypes.string,
  // onChange: function to be called when input value changes. called with unredacted, unmasked, still formatted e.target.value
  onChange: PropTypes.func,
  // a Component that forwards the 'ref' to an underlying input or textarea component
  component: PropTypes.elementType
};
InputFormattedPattern.defaultProps = {
  redaction: '',
  mask: '',
  onChange: function onChange() {},
  component: 'input'
};